// extracted by mini-css-extract-plugin
module.exports = {"serif":"styles-module--serif--3glAI","sans":"styles-module--sans--1RUUJ","accent":"styles-module--accent--2pVDR","LinkButton":"styles-module--LinkButton--3QUZq"};